import GraphQLClient from '../../core/adapter/graphQLClient';
import Result from '../../entity/result';
import Session from '../../entity/session';
import validShipAreaByOrder from './query/validShipAreaByOrder';
import validMinPriceByOrder from './query/validMinPriceByOrder';
import Order from "../../entity/order";

class ValidateRepository {
  private graphqlClient: GraphQLClient;

  constructor({ graphqlClient }: { graphqlClient: GraphQLClient }) {
    this.graphqlClient = graphqlClient;
  }

  public validShipAreaByOrder(
    session: Session,
    order: Order,
  ): Promise<Result> {
    return this.graphqlClient
      .query(session, validShipAreaByOrder, { variables: { order: order.toJson() }})
      .then(({ data }: { data: any }) => Result.fromJson(data['validShipAreaByOrder']));
  }

  public validMinPriceByOrder(
    session: Session,
    order: Order,
  ): Promise<Result> {
    return this.graphqlClient
      .query(session, validMinPriceByOrder, { variables: { order: order.toJson() }})
      .then(({ data }: { data: any }) => Result.fromJson(data['validMinPriceByOrder']));
  }
}

export default ValidateRepository;
